import Konva from "konva";

export default class Shuttle extends Konva.Rect {
  tween: Konva.Tween | null = null;
}
